import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Calculator from "./Calculator";
import { ToolWrapper } from "@tanyoknits/shared";

ReactDOM.render(
  <React.StrictMode>
    <ToolWrapper
      title="Just Right Stitch Pick Up"
      subtitle="For cardigan button band"
      message="Hello knitters - check out this button band stitch pick up calculator"
      url="https://tanyoknits.github.io/button-band"
    >
      <Calculator />
    </ToolWrapper>
  </React.StrictMode>,
  document.getElementById("root")
);
